import { ElMessage, ElNotification } from 'element-plus'

/**
 * Toast 提示工具
 * 提供轻量级的操作反馈
 */

export const toast = {
  /**
   * 成功提示
   */
  success: (message: string, duration: number = 2000) => {
    ElMessage({
      message,
      type: 'success',
      duration,
      showClose: true,
    })
  },

  /**
   * 错误提示
   */
  error: (message: string, duration: number = 3000) => {
    ElMessage({
      message,
      type: 'error',
      duration,
      showClose: true,
    })
  },

  /**
   * 警告提示
   */
  warning: (message: string, duration: number = 2500) => {
    ElMessage({
      message,
      type: 'warning',
      duration,
      showClose: true,
    })
  },

  /**
   * 信息提示
   */
  info: (message: string, duration: number = 2000) => {
    ElMessage({
      message,
      type: 'info',
      duration,
      showClose: true,
    })
  },

  /**
   * 加载中提示
   */
  loading: (message: string = '加载中...') => {
    return ElMessage({
      message,
      type: 'info',
      duration: 0,
      icon: 'Loading',
    })
  },
}

/**
 * 通知提示（用于重要操作）
 */
export const notify = {
  success: (title: string, message?: string) => {
    ElNotification({
      title,
      message,
      type: 'success',
      duration: 3000,
    })
  },

  error: (title: string, message?: string) => {
    ElNotification({
      title,
      message,
      type: 'error',
      duration: 4000,
    })
  },

  warning: (title: string, message?: string) => {
    ElNotification({
      title,
      message,
      type: 'warning',
      duration: 3500,
    })
  },

  info: (title: string, message?: string) => {
    ElNotification({
      title,
      message,
      type: 'info',
      duration: 3000,
    })
  },
}

export default toast
